import React from "react";
import { CustomTable } from "../utils/CustomComponents";
import { Typography } from "antd";
const { Text } = Typography;

const ShowFollowUpData = ({ data }) => {
	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Date",
			dataIndex: "createdAt",
			key: "createdAt",
			render: (value) => {
				return (
					<Text>
						{new Intl.DateTimeFormat("en-US", {
							month: "numeric",
							year: "numeric",
							day: "numeric",
							hour: "2-digit",
							minute: "2-digit",
							second: "2-digit",
						}).format(new Date(value))}
					</Text>
				);
			},
		},
		{
			title: "Contact Global",
			dataIndex: "contactGlobal",
			key: "contactGlobal",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Type",
			dataIndex: "type",
			key: "type",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Created By",
			dataIndex: "createdBy",
			key: "createdBy",
			render: (value) => {
				return <Text>{value.name}</Text>;
			},
		},
	];

	return <CustomTable columns={columns} data={data} isScroll={false} />;
};

export default ShowFollowUpData;
